/* eslint-disable import/prefer-default-export */
/* eslint-disable no-console */
export function debugAction(action) {
  if (process.env.REACT_APP_ENV === 'debug') {
    console.warn({ action: action.type, payload: action.payload });
  }
}
